import React from 'react';
const Form = React.forwardRef((props, ref) => {
    const { children, style } = props;
    return (React.createElement("div", { ref: ref, style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            padding: 16,
            ...style,
        } }, children));
});
Form.displayName = 'Form';
export { Form };
